let lastTouchEndTime = 0

export function disablePageZoom() {
  document.addEventListener('gesturestart', preventDefault, { passive: false })
  document.addEventListener('gesturechange', preventDefault, { passive: false })
  document.addEventListener('gestureend', preventDefault, { passive: false })

  document.addEventListener('touchmove', event => {
    if (event.touches && event.touches.length > 1) {
      event.preventDefault()
    }
  }, { passive: false })

  document.addEventListener('touchend', event => {
    const now = Date.now()
    if (now - lastTouchEndTime <= 300) {
      event.preventDefault()
    }
    lastTouchEndTime = now
  }, { passive: false })
}

function preventDefault(event) {
  event.preventDefault()
}



// WEBPACK FOOTER //
// ./src/utils/disable-zoom.js